import { useState } from "react";
import pic4 from "../Assets/Images/pic4.jpg";
import Swal from "sweetalert2";
import { submitContactMessage } from "../Services/ContactService";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });
  const [sending, setSending] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const payload = {
      firstName: formData.firstName.trim(),
      lastName: formData.lastName.trim(),
      email: formData.email.trim(),
      message: formData.message.trim(),
    };

    if (!payload.firstName || !payload.lastName || !payload.email || !payload.message) {
      await Swal.fire({
        icon: "error",
        title: "Incomplete form",
        text: "First name, last name, email, and message are required.",
      });
      return;
    }

    setSending(true);

    try {
      const response = await submitContactMessage(payload);

      await Swal.fire({
        icon: "success",
        title: "Message sent",
        text: response.data?.message || "Message sent successfully",
      });

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        message: "",
      });
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Send failed",
        text:
          error.response?.data?.error ||
          error.response?.data?.message ||
          "Unable to send your message right now.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-[100%] overflow-hidden bg-body animate-[pageFade_0.6s_ease-out]">
      <div className="px-4 pb-4 sm:px-6 lg:pb-10">
        <div className="mb-10 mt-3 md:mt-14 hidden md:block">
          <h1 className="text-center text-3xl font-bold text-primary-default sm:text-4xl">
            Contact Us
          </h1>
        </div>

        <div className="mx-auto max-w-7xl">
          <div
            className="relative overflow-hidden rounded-2xl p-5 sm:p-8 md:p-10"
            style={{
              backgroundImage: `url(${pic4})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="grid items-center gap-5 lg:grid-cols-2 lg:gap-10">
              <div className="relative space-y-3 animate-fadeInUp delay-200 lg:-top-10">
                <div className="inline-flex rounded-full bg-accent-gold/20 px-4 py-1 md:py-2 text-xs md:text-sm font-semibold text-accent-gold">
                  GET IN TOUCH
                </div>

                <h2 className="text-lg md:text-2xl font-bold leading-tight text-neutral-white md:text-4xl">
                  Get Free Consultation Today
                </h2>

                <p className="max-w-md text-base text-neutral-white/80 sm:text-lg">
                  Feel free to ask anything. Our experts are here to guide you.
                </p>

                <div className="space-y-3 md:pt-4 pt-2">
                  <div className="group flex items-center gap-4">
                    <div className="flex md:h-10 md:w-10 h-6 w-6 items-center justify-center rounded-lg bg-accent-gold transition-transform group-hover:scale-110">
                      <svg
                        className="md:h-5 md:w-5 h-4 w-4 text-primary-dark"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-sm text-neutral-white/60">Phone</div>
                      <div className="font-medium text-neutral-white">
                        +91 94355 64566
                      </div>
                    </div>
                  </div>

                  <div className="group flex items-center gap-4">
                    <div className="flex md:h-10 md:w-10 h-6 w-6 items-center justify-center rounded-lg bg-accent-gold transition-transform group-hover:scale-110">
                      <svg
                        className="md:h-5 md:w-5 h-4 w-4 text-primary-dark"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-sm text-neutral-white/60">Email</div>
                      <div className="break-all font-medium text-neutral-white sm:break-normal">
                        wealthgrowfintaxservices@gmail.com
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="rounded-xl bg-neutral-white p-4 md:p-5 shadow-[0_20px_40px_rgba(0,0,0,0.1)] animate-fadeIn sm:p-6 md:p-8">
                <form className="md:space-y-5 space-y-2" onSubmit={handleSubmit}>
                  <div className="grid gap-2 md:gap-4 md:grid-cols-2">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="input"
                    />
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={formData.lastName}
                      onChange={handleChange}
                      className="input"
                    />
                  </div>

                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    className="input"
                  />

                  <textarea
                    rows="3"
                    name="message"
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    className="input resize-none"
                  />

                  <button
                    type="submit"
                    disabled={sending}
                    className="w-full rounded-lg bg-primary-default md:py-3 py-2 font-semibold text-neutral-white transition-all duration-300 hover:bg-primary-light hover:shadow-lg"
                  >
                    {sending ? "Sending..." : "Send Message"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
